import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import { Input, Button } from 'antd';
import message from '@web-common/components/UI/Message/SiriusMessage';
import { tarnsEntityContact2ContactItem } from '@web-common/components/util/contact';
import SelectList from '../selectList';
import SelectedList from '../selectedList';
import styles from './index.module.scss';
import { SiriusHtmlModal } from '@web-common/components/UI/Modal/SiriusModal';
import { api, apis } from 'api';
import ContactForm from '@web-common/components/UI/SiriusContact/personal/ContactForm';
import { PersonaMarkCheckbox } from '../personalMark/markTip';
import { StaticRootNodeKey } from '@web-common/utils/contact_util';
import { getIn18Text } from 'api';
import useStateRef from '@web-mail/hooks/useStateRef';
const contactApi = api.requireLogicalApi(apis.contactApiImpl);
const accountApi = api.requireLogicalApi(apis.accountApiImpl);
const systemApi = api.getSystemApi();
const EmptySelectedContact = [];
const PersonalOrgModal = props => {
    var _a;
    const { personalOrgId, modelZIndex = 100, onCancel, onSure, _account = ((_a = systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id) || '', defaultSelectedContact = EmptySelectedContact } = props;
    const [needScrollBottom, setNeedScrollBottom] = useState(true);
    const [canSure, setCanSure] = useState(true);
    const [name, setName] = useState('');
    const [personalMarked, setPersonalMarked] = useState(false);
    const [nameError, setNameError] = useState('');
    const [visibleCreateContact, setVisibleCreateContact] = useState(false);
    const [selectList, setSelectList] = useState(defaultSelectedContact);
    const defaultSelectedContactRef = useStateRef(defaultSelectedContact);
    const isEdit = !!personalOrgId;
    const handleDelete = (itemList) => {
        setSelectList(itemList);
        setNeedScrollBottom(false);
    };
    const handleSelect = (itemList) => {
        setSelectList(itemList);
        setNeedScrollBottom(true);
    };
    const handleCancel = () => {
        onCancel();
    };
    const handleSure = async () => {
        if (nameError) {
            return;
        }
        const personalIdSet = new Set();
        const enterpriseEmailMap = new Map();
        selectList.forEach(item => {
            if (item.type === 'enterprise') {
                enterpriseEmailMap.set(item.email, item);
            }
            else {
                item.id && personalIdSet.add(item.id);
            }
        });
        if (enterpriseEmailMap.size) {
            const personalEmailList = await contactApi.doGetContactByItem({
                type: 'EMAIL',
                value: [...enterpriseEmailMap.keys()],
                filterType: 'personal',
                _account,
            });
            personalEmailList.forEach(item => {
                const { contact: { accountName: email, contactName: name, id }, contactInfo, } = item;
                if (enterpriseEmailMap.has(email)) {
                    const currentItem = enterpriseEmailMap.get(email);
                    if (email === currentItem.email && currentItem.name === name) {
                        const len = contactInfo.filter(info => info.contactItemType === 'EMAIL').length;
                        if (len === 1) {
                            personalIdSet.add(id);
                            enterpriseEmailMap.delete(email);
                        }
                    }
                }
            });
            const enterpriseList = [];
            enterpriseEmailMap.forEach(item => {
                enterpriseList.push({
                    name: item.name,
                    emailList: [item.email],
                    groupIdList: [],
                });
            });
            if (enterpriseList.length) {
                const { success, data: insertPersonalList, error, } = await contactApi.doInsertContact({
                    list: enterpriseList,
                    _account,
                });
                if (success && insertPersonalList) {
                    insertPersonalList.forEach(item => {
                        personalIdSet.add(item.contact.id);
                    });
                }
                else {
                    message.error(error || `${isEdit ? getIn18Text('BIANJI') : getIn18Text('TIANJIA')}分组失败`);
                    return;
                }
            }
        }
        const { success, data, message: error, } = isEdit
            ? await contactApi.doUpdatePersonalOrg({
                groupName: name === null || name === void 0 ? void 0 : name.trim(),
                orgId: personalOrgId,
                idList: [...personalIdSet],
                isMark: personalMarked,
                _account,
            })
            : await contactApi.doInsertPersonalOrg({
                groupName: name === null || name === void 0 ? void 0 : name.trim(),
                idList: [...personalIdSet],
                isMark: personalMarked,
                _account,
            });
        if (success && data) {
            message.success(`${isEdit ? getIn18Text('BIANJI') : getIn18Text('TIANJIA')}分组成功`);
            onSure(data.id, data.name, _account);
        }
        else {
            message.error(error || `${isEdit ? getIn18Text('BIANJI') : getIn18Text('TIANJIA')}分组失败`);
        }
    };
    const handleInputChange = (e) => {
        var _a, _b;
        const newName = (_a = e.target) === null || _a === void 0 ? void 0 : _a.value;
        setName(newName);
        const trimName = newName === null || newName === void 0 ? void 0 : newName.trim();
        const zhReg = /[\u4e00-\u9fa5]/g;
        const zhLen = ((_b = trimName.match(zhReg)) === null || _b === void 0 ? void 0 : _b.length) || 0;
        if (trimName.length + zhLen <= 40) {
            setNameError('');
        }
        else {
            setNameError(getIn18Text('ZUIDUOKESHURU'));
        }
    };
    const onCreateContact = (item) => {
        setVisibleCreateContact(false);
        setSelectList([...selectList, item]);
    };
    useEffect(() => {
        setCanSure(!!name && !nameError);
    }, [name, nameError]);
    useEffect(() => {
        if (personalOrgId) {
            contactApi.doGetPersonalOrg({ idList: [personalOrgId], _account }).then(({ success, data }) => {
                if (success && (data === null || data === void 0 ? void 0 : data.length)) {
                    setName(data[0].orgName);
                    const isMark = data[0].marked && data[0].marked > 0;
                    setPersonalMarked(!!isMark);
                }
            });
            contactApi.doGetContactByOrgId({ orgId: personalOrgId, _account }).then(res => {
                setSelectList(res.map(item => tarnsEntityContact2ContactItem(item.contact)));
            });
        }
        else {
            setName('');
            setSelectList(defaultSelectedContactRef.current);
        }
    }, [personalOrgId]);
    return (React.createElement(SiriusHtmlModal, { visible: true, width: 640, zIndex: modelZIndex, destroyOnClose: true, closable: false, title: null, footer: null },
        React.createElement("div", { className: styles.wrap, "data-test-id": "modal_personalOrg" },
            React.createElement("div", { className: styles.modalTitle },
                React.createElement("div", { className: styles.titleName },
                    React.createElement("i", { className: `dark-invert ${styles.icon}`, hidden: !visibleCreateContact, onClick: () => setVisibleCreateContact(false) }),
                    React.createElement("span", { "data-test-id": "modal_personalOrg_title" }, visibleCreateContact ? getIn18Text('XINJIANLIANXIREN') : isEdit ? getIn18Text('BIANJIGERENFEN') : getIn18Text('XINJIANGERENFEN'))),
                React.createElement("div", { className: styles.close, onClick: handleCancel })),
            React.createElement("div", { className: styles.modalContent },
                React.createElement("div", { className: styles.createFormWrap, hidden: !visibleCreateContact }, visibleCreateContact && (React.createElement(ContactForm, { _account: _account, from: "personalOrgModal", onCancel: () => {
                        setVisibleCreateContact(false);
                    }, onSuccess: onCreateContact }))),
                React.createElement("div", { className: styles.modalContent, hidden: visibleCreateContact },
                    React.createElement("div", { className: styles.modalInputContainer },
                        React.createElement("div", { className: `ant-allow-dark ${styles.modalInputWrap}` },
                            React.createElement(Input, { "data-test-id": "modal_personalOrg_name", autoFocus: true, placeholder: getIn18Text('QINGSHURUXINFEN'), onChange: handleInputChange, value: name, className: classnames(styles.modalInput, {
                                    [styles.error]: nameError,
                                }) }),
                            React.createElement("div", { className: styles.inputError }, nameError)),
                        React.createElement(PersonaMarkCheckbox, { testId: "modal_personalOrg_mark_checkbox", style: { marginLeft: 16, marginBottom: 16 }, onChange: (isMarked) => setPersonalMarked(isMarked), value: personalMarked })),
                    React.createElement("div", { className: styles.subTitle },
                        React.createElement("span", { className: styles.subName, "datat-test-id": "modal_personalOrg_select_title" }, getIn18Text('XUANZEZUCHENGYUAN')),
                        React.createElement("span", { "data-test-id": "modal_personalOrg_btn_addContact", className: styles.createContact, onClick: () => setVisibleCreateContact(true) }, getIn18Text('XINJIANLIANXIREN'))),
                    React.createElement("div", { className: styles.modalBody },
                        React.createElement("div", { className: styles.bodyLeft },
                            React.createElement(SelectList, { showNoDataPlaceholder: true, useMultiAccount: false, accountRootKey: _account, isIM: false, useContactId: true, searchAutoFocus: false, type: ['personal', 'enterprise'], defaultSelectList: selectList, defaultExpandedKeys: [StaticRootNodeKey.ENTERPRISE, StaticRootNodeKey.PERSON], showAddOrgBtn: true, showAddPersonalBtn: true, onSelect: handleSelect })),
                        React.createElement("div", { className: styles.bodyRight },
                            React.createElement(SelectedList, { useContactId: true, showPosition: false, selectList: selectList, onDelete: handleDelete, needScrollBottom: needScrollBottom, showFooter: false }))),
                    React.createElement("div", { className: styles.modalFooter },
                        React.createElement(Button, { "data-test-id": "modal_personalOrg_btn_cancel", type: "default", className: styles.cancelBtn, onClick: () => {
                                handleCancel();
                            } }, getIn18Text('QUXIAO')),
                        React.createElement(Button, { "data-test-id": "modal_personalOrg_btn_save", disabled: !canSure, type: "primary", className: styles.sureBtn, onClick: () => {
                                handleSure();
                            } }, getIn18Text('QUEDING'))))))));
};
export default PersonalOrgModal;
